import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarHeadingTitle from "../../SidebarHeadingTitle";
import InventoryList from "./InventoryList";

import {SidebarContext} from "../../../../../SidebarContext";

function InventoryMenuContent(props) {
    const {isMobile} = useContext(SidebarContext);

    return (
        <div style={{...!isMobile && {padding: '12px'}}}>
            <SidebarHeadingTitle>
                <FormattedMessage id='sidebar.inventory.menu.title' />
            </SidebarHeadingTitle>
            <InventoryList />
        </div>
    );
}

export default InventoryMenuContent;
